import type { ILawCardsProps } from './ILawCardsProps';

/**
 * «Правки» (прототип v4 lzWork): три картки поруч (від 280px) — «Правки», «Коментарі до тексту», «Версії»; запис — кнопка: назва й
 * пігулка статусу, підрядок і текст.
 */
export function LawWork({ sections, onOpen }: ILawCardsProps) {
  return (
    <div className="law-cards">
      {sections.map((s) => (
        <section key={s.rt} className="law-sec law-sec--tight">
          <div className="law-sec__title">{s.title}</div>
          {s.cards.map((c) => (
            <button key={c.record.id} type="button" className={`law-card law-t-${c.tone}`} onClick={() => onOpen(c.rt, c.record)}>
              <span className="law-card__top"><strong className="law-card__label">{c.label}</strong><span className="law-card__pill">{c.status}</span></span>
              <span className="law-card__meta">{c.meta}</span>
              <span className="law-card__text">{c.text}</span>
            </button>
          ))}
        </section>
      ))}
    </div>
  );
}
